export default {"src":"/_next/static/media/step2g.47f0f240.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};